/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PreloadedQuery } from 'react-relay';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import QUERY, {
	type HorizontalNavJiraInnerQuery,
} from '@jira/navigation-apps__horizontal-nav-jira/src/ui/__generated__/HorizontalNavJiraInnerQuery.graphql';
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import { JiraProjectAri } from '@atlassian/ari/jira/project';
import type { RouteResource } from '@atlassian/react-resource-router';
import { withGiraAggAnonSsrFix } from '../../../common/utils.tsx';

const NAVIGATION_ITEMS_PAGE_SIZE = 75;

export const getQuery: Parameters<
	typeof createRelayResource<HorizontalNavJiraInnerQuery>
>[0]['getQuery'] = ({ match, query }, { tenantContext: { cloudId } }) => {
	const boardId = match.params.boardId;
	let { projectKey, projectId } = getProjectKeyId(match, query);
	projectKey = projectKey ?? '';
	projectId = projectId ?? '';
	const projectIdOrKey = projectId || projectKey;

	const isTMPBoardRoute = boardId ? match.url.includes('/software/projects/') : false;

	const boardAri = boardId ? `ari:cloud:jira-software:${cloudId}:board/${boardId}` : '';

	const projectAri = projectId
		? JiraProjectAri.create({
				siteId: cloudId,
				projectId,
			}).toString()
		: '';

	let containerNavigationInput;
	if (isTMPBoardRoute) {
		containerNavigationInput = projectAri
			? { scopeId: boardAri }
			: { projectKeyQuery: { cloudId, projectKey } };
	} else {
		containerNavigationInput =
			boardAri || projectAri
				? { scopeId: boardAri || projectAri }
				: { projectKeyQuery: { cloudId, projectKey } };
	}

	return {
		options: { fetchPolicy: 'store-and-network' },
		parameters: QUERY,
		variables: {
			cloudId,
			projectIdOrKey,
			withProject: Boolean(projectIdOrKey),
			boardId: boardAri,
			withBoard: Boolean(boardAri),
			containerNavigationInput,
			isTMPBoardRoute,
			first: NAVIGATION_ITEMS_PAGE_SIZE,
		},
	};
};

const horizontalNavJiraResourceActual = withGiraAggAnonSsrFix(
	createRelayResource<HorizontalNavJiraInnerQuery>({
		type: 'HORIZONTAL_NAVIGATION_JIRA_QUERY',
		getQuery,
	}),
);

export const horizontalNavJiraResource: RouteResource<
	PreloadedQuery<HorizontalNavJiraInnerQuery, Record<string, unknown>>
> = horizontalNavJiraResourceActual;
